/**
 * Files picked for upload, kept out of the upload state since a File cannot be
 * serialized. The state refers to one by the id registerFile returns. A File
 * cannot be revived after a reload, so the registry lives for the tab only.
 */
const files = new Map<string, File>();

export const registerFile = (file: File): string => {
  const id = crypto.randomUUID();
  files.set(id, file);
  return id;
};

export const getRegisteredFile = (id: string): File | undefined =>
  files.get(id);

export const unregisterFile = (id: string): void => {
  files.delete(id);
};
